import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

const InformacionAdicionalModelo303 = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<DeclaracionModelo303DtoProps>
  watch: UseFormWatch<DeclaracionModelo303DtoProps>
}) => {
  const { t } = useTranslation()
  const values = watch()
  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.adicionalInfo.box1")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30303?.casilla59}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='59'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla59", value)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.adicionalInfo.box2")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30303?.casilla60}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='60'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla60", value)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.adicionalInfo.box3")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30303?.casilla120}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='120'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla120", value)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.adicionalInfo.box4")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30303?.casilla122}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='122'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla122", value)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.adicionalInfo.box5")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30303?.casilla123}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='123'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla123", value)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.adicionalInfo.box6")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30303?.casilla124}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='124'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla124", value)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-justify-start tw-items-center'>
          {t("taxSummary.declaracion.adicionalInfo.box7")}
        </span>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.adicionalInfo.box7titleOne")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30303?.casilla62}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='62'
            disabled={!values.dp30301?.criterioDeCaja}
            onChange={(value: number | undefined) =>
              setValue("dp30303.casilla62", value)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.adicionalInfo.box7titleTwo")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30303?.casilla63}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='63'
            disabled={!values.dp30301?.criterioDeCaja}
            onChange={(value: number | undefined) =>
              setValue("dp30303.casilla63", value)
            }
          />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-justify-start tw-items-center'>
          {t("taxSummary.declaracion.adicionalInfo.box8")}
        </span>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.adicionalInfo.box7titleOne")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30303?.casilla74}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='74'
            disabled={
              !(
                values.dp30301?.criterioDeCaja ||
                values.dp30301?.operacionesCriterioDeCaja
              )
            }
            onChange={(value: number | undefined) =>
              setValue("dp30303.casilla74", value)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.adicionalInfo.box7titleTwo")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30303?.casilla75}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='75'
            disabled={
              !(
                values.dp30301?.criterioDeCaja ||
                values.dp30301?.operacionesCriterioDeCaja
              )
            }
            onChange={(value: number | undefined) =>
              setValue("dp30303.casilla75", value)
            }
          />
        </div>
      </div>
      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}

export default InformacionAdicionalModelo303
